import {NuxtIcon} from "#components";
import {h} from "vue";
import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  id: "i-408610590__Layer_2",
  "data-name": "Layer 2",
  viewBox: "0 0 475.79 158.71"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(".i-408610590__cls-2{fill:#fff}")
        ])),
        _: 1
      }))
    ]),
    _cache[1] || (_cache[1] = _createElementVNode("g", {
      id: "i-408610590__Layer_1-2",
      "data-name": "Layer 1"
    }, [
      _createElementVNode("path", {
        d: "M237.91 121.02c-23.01 0-41.66-18.65-41.66-41.66S214.9 37.7 237.91 37.7s41.66 18.65 41.66 41.66-18.65 41.66-41.66 41.66",
        style: {"fill":"#dc3c96"}
      }),
      _createElementVNode("path", {
        d: "M237.91 120.62c-22.79 0-41.27-18.47-41.27-41.27s18.48-41.26 41.27-41.26 41.27 18.47 41.27 41.26-18.48 41.27-41.27 41.27m0-120.62c-43.83 0-79.35 35.53-79.35 79.36s35.53 79.36 79.35 79.36 79.35-35.53 79.35-79.36S281.73 0 237.91 0M160.32 16.54V2.75h-39.68v76.61c0 22.79-18.56 41.24-41.35 41.24-21.18 0-38.71-15.69-41.07-36.52H0c2.47 41.66 36.97 74.61 79.2 74.61 28.65 0 53.75-15.18 67.7-37.94-5.75-12.62-8.89-26.63-8.89-41.4 0-23.8 8.42-45.65 22.31-62.82M354.56 79.36c0-23.23 18.83-42.06 42.06-42.06a42 42 0 0 1 13.97 2.4l-53.64 53.64a42.01 42.01 0 0 1-2.39-13.98m83.84 4.72c-2.37 20.83-20.17 37.31-41.78 37.31-4.9 0-9.61-.84-13.98-2.38l81.43-81.43C450.08 15.03 425.11 0 396.62 0s-53.75 15.2-67.69 37.97c5.74 12.61 8.97 26.62 8.97 41.38s-3.23 28.77-8.97 41.38c13.95 22.77 39.03 37.95 67.69 37.95 42.22 0 76.7-32.95 79.17-74.61H438.4Z",
        class: "i-408610590__cls-2"
      })
    ], -1))
  ]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "joe_logo_white"}) } }